import { Image } from "@wss/image";
import React from "react";
import { useHomePageData } from "../utilities";
const FoodserviceResources = () => {
  const {
    resources
  } = useHomePageData();
  return resources && <>
        <div className="container pt-6 pb-10 ">
          <div className="mx-auto w-full box-border" data-testid="food-service-resources">
            <div className="flex justify-center items-center xxs:items-baseline mb-4">
              <h2 className="text-center text-gray-800 text-xl xxs:text-2xl md:text-3xl mb-0" style={{
            lineHeight: "0.75"
          }}>
                Foodservice Resources
              </h2>
              <a href="/food-service-resources.html">
                <span className="text-center leading-0 xxs:leading-10 md:leading-12 pl-5 text-base">
                  View More{" "}
                  <span className="text-xs" aria-hidden="true">
                    &#10095;
                  </span>
                </span>
              </a>
            </div>
            <div className="flex">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-4">
                {resources.map((x, index) => <>
                    <a href={x.link} className="border-0 md:border rounded border-solid border-gray-200 border-px">
                      <div className="flex flex-row md:flex-col">
                        <div className="w-1/3 xsl:w-1/2 md:w-full">
                          <Image data-testid={x.altText} src={x.image} alt="" width={120} height={47} loading="lazy" aria-hidden="true" className="w-full h-full md:h-auto rounded md:rounded-none md:rounded-t" />
                        </div>
                        <div className="w-2/3 xsl:w-1/2 md:w-full bg-white overflow-hidden flex flex-col rounded-md" data-testid="resource" key={x.id}>
                          <div className="rounded-b text-left">
                            <h3 className="fsr_heading break-words m-0 pt-0 xsl:pt-4 px-6 text-base lt:text-xl text-gray-800 font-bold group-hover:underline">
                              {x.altText}
                            </h3>
                            <p className="m-0 mt-1 xs:mt-2 px-6 pb-0 md:pb-5 text-xs md:text-base font-semibold text-green-500 hover:text-green-900">
                              Read More
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                    {index < resources.length - 1 && <hr aria-hidden="true" className="border border-t-0 border-gray-200 my-2 md:hidden" />}
                  </>)}
              </div>
            </div>
          </div>
        </div>
      </>;
};
export default FoodserviceResources;